import React from 'react';
import { NextFutureImage } from '@components/main-components/image/NextFutureImage';
import { blurImage } from '@components/main-components/image/blur-image';
import { AccessibleLink } from '@components/main-components/link/AccessibleLink';
import { useAudioController } from '@store/audio/AudioController';
import { webappUriPath } from '@utils/url';
import { SongTitle } from './SongTitle';
import { usePlayerTrackInfo } from './usePlayerTrackInfo';

const IMAGE_SIZE = 56;

export const SongInfo = () => {
  const { activeTrackId } = useAudioController();

  const { releaseInfo } = usePlayerTrackInfo({
    trackId: activeTrackId,
    shouldFetch: true,
  });

  if (!releaseInfo) return null;

  const staticCoverImageUrl = releaseInfo.staticCoverImage?.url;
  const coverImageUrl = releaseInfo.coverImage.url ?? '';
  const artistName = releaseInfo.artist.name ?? 'Unnamed Artist';
  const songTitle = releaseInfo.title ?? 'Unnamed Song';

  const songUrl = webappUriPath(releaseInfo.webappUri);
  const artistUrl = webappUriPath(releaseInfo.artist.webappUri);
  return (
    <div className="flex h-full w-full items-center gap-3">
      <div className="h-14 w-14 self-center overflow-hidden rounded-sm">
        <AccessibleLink
          pathnameUri={songUrl}
          className="relative h-full w-full overflow-hidden rounded-sm"
        >
          <NextFutureImage
            placeholder="blur"
            src={staticCoverImageUrl || coverImageUrl}
            blurDataURL={blurImage(IMAGE_SIZE, IMAGE_SIZE)}
            alt={songTitle}
            height={IMAGE_SIZE * 2}
            width={IMAGE_SIZE * 2}
          />
        </AccessibleLink>
      </div>
      <div className="mr-6 flex flex-1 flex-col overflow-hidden">
        <SongTitle songTitle={songTitle} webappUri={releaseInfo.webappUri} />
        <div className="font-base text-base-xs font-medium text-base500">
          <AccessibleLink pathnameUri={artistUrl}>
            <span className="inline-block ">{artistName}</span>
          </AccessibleLink>
        </div>
      </div>
    </div>
  );
};
